module.exports = __webpack_public_path__ + "static/media/MICHELL T2 TONEARM.29386bdc.png";